// utils/getDomainFromUrl.js

/**
 * Safely parses out the domain/hostname from a given URL string.
 * @param {string} imageUrl - The full URL of the image
 * @returns {string} The domain (e.g., "example.com") or empty string if invalid
 */
export function getDomainFromUrl(imageUrl) {
    try {
      const urlObj = new URL(imageUrl);
      return {
        protocol: urlObj.protocol, // e.g. 'https:' or 'http:'
        hostname: urlObj.hostname, // e.g. 'example.com'
      };
    } catch (err) {
      console.error("Invalid imageUrl for domain parsing:", imageUrl);
      return "";
    }
  }
  